import React, { useEffect, useState } from 'react'
import { t } from 'i18next'
import Product from '../Product'
import './productList.css'
import MiniLoading from '../MiniLoading'
import styles from './productList.module.css'
import MaterialsCalculator from 'Components/MaterialsCalculator/MaterialCalculator'
import Modal from 'react-bootstrap/Modal'
import { emptyCart } from 'redux/actions/cartActions'
import { useDispatch } from 'react-redux'
import { MATERIALS_CALCULATOR_CEILING_PARAM, ROUTES } from 'Utils/constants'
import { useHistory } from 'react-router-dom'

function ProductList({
  products,
  setProductCart,
  successAlgoliaHits,
  productsRef,
  productsLoading,
  hasMore,
  handlePage,
  inListScreen,
  currentCategory,
  productSearchText,
  setShowMaterialsCalculatorPDP,
  setProductDetail,
}) {
  const [productsList, setProductsList] = useState([])
  const [showMaterialsCalculatorPLP, setShowMaterialsCalculatorPLP] =
    useState(false)

  useEffect(() => {
    setProductsList(products)
  }, [products])
  const dispatch = useDispatch()
  const history = useHistory()
  const showCalculatorAds =
    (currentCategory?.includes('Cielo rasos') && currentCategory?.length > 0) ||
    productSearchText.toLowerCase().includes('cielo raso') ||
    productSearchText.toLowerCase().includes('cielo rasos')

  return (
    <>
      <div
        className={'products-cotizacion-content'}
        data-testid="container-product-list">
        <div
          className="product-cards-wrapper"
          data-testid="wrapper-product-cards">
          {!productsLoading && showCalculatorAds && (
            <div
              className="product-card2 background-image"
              data-testid="card-materials-calculator-ad"
              onClick={() => {
                history.push(
                  `${ROUTES.materialsCalculator}?${MATERIALS_CALCULATOR_CEILING_PARAM}`
                )

                dispatch(emptyCart())
              }}></div>
          )}
          {productsList.length > 0
            ? productsList.map(product => {
                return (
                  <div key={product.ExternalCodes[0]?.ProductId}>
                    <Product
                      product={product}
                      // setProductCart={setProductCart}
                      productsRef={productsRef}
                      inListScreen={inListScreen}
                      setShowMaterialsCalculatorPDP={
                        setShowMaterialsCalculatorPDP
                      }
                      setProductDetail={setProductDetail}
                    />
                  </div>
                )
              })
            : !successAlgoliaHits && (
                <div
                  className={styles.noResultsContainer}
                  data-testid="container-no-results">
                  <h3>{t('PRODUCTS_SEARCH_T.RESULTS_NOT_FOUND')}</h3>
                </div>
              )}
        </div>
        {productsLoading ? (
          <div className="load-more-button" data-testid="loading-products">
            <MiniLoading productsLoading={productsLoading} />
          </div>
        ) : products.length > 0 && hasMore ? (
          <div className="load-more-button" data-testid="btn-load-more">
            <button onClick={() => handlePage()} disabled={productsLoading}>
              Ver más...
            </button>
          </div>
        ) : (
          <div className="load-more-button" data-testid="empty-load-more" />
        )}
      </div>
      <Modal
        backdrop={false}
        fullscreen={true}
        show={showMaterialsCalculatorPLP}
        data-testid="modal-materials-calculator">
        <MaterialsCalculator
          showCalculator={showMaterialsCalculatorPLP}
          setShowCalculator={setShowMaterialsCalculatorPLP}
          isPLP
        />
      </Modal>
    </>
  )
}

export default ProductList
